import { getInfo } from "lib/Cookies"
import { getDeviceIdFromLocal } from "lib/func"
import { useEffect, memo, useRef } from "react"
import { getTracking } from "hooks/useTracking"

let player, LiveOverlay

const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream

const hardResetContainer = () => {
  const container = document.querySelector("#container")
  if (container) {
    console.warn("[VlinePlayer] hard reset container")
    container.innerHTML = ""
  }
}

const safeDestroyPlayer = () => {
  if (!player) return

  console.warn("[VlinePlayer] destroy old player")
  try {
    player.destroy()
  } catch (e) {
    console.warn("destroy error", e)
  }
  player = null
}

function VlinePlayer(props) {
  const {
    signKey,
    src,
    isProtected,
    isTimeshift,
    contentId,
    name,
    startTime,
    content_warning,
    children,
    isLive,
    skip_ads,
    handleError,
    id,
    channelId,
    programmeId,
    age,
    channelTitle,
    isChannel
  } = props
  const isChannelRef = useRef(isChannel)

  useEffect(() => {
    isChannelRef.current = isChannel
  }, [isChannel])

  useEffect(() => {
    const container = document.querySelector("#container")

    const initializePlayer = async () => {
      if (container && src) {
        const { VinasportsPlayer } = window.playerSDK
        const deviceId = getDeviceIdFromLocal()

        if (player) {
          player.destroy()
        }

        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
        console.log(
          "[DBG-1] isMobile:",
          isMobile,
          "| isSafari:",
          isSafari,
          "| isIOS:",
          isIOS(),
          "| isProtected:",
          isProtected,
          "| src:",
          src?.substring(0, 80)
        )
        const userInfo = getInfo()
        const currentTimestamp = Math.floor(Date.now() / 1000)

        const adTagUrl = `https://delivery.upremium.asia/publishers/vast.xml?adserver_id=49c0b3d79f9d123d72e249&item_id=6a87a766188f5e4ff80ede&UK_URL=${encodeURIComponent(
          window.location.href
        )}&cb=${Date.now()}&app_url=${encodeURIComponent(
          window.location.hostname
        )}&bundle=&device_id=${deviceId}&device_type=&uk_tracking_events=1&width=1280`

        const fetchSpringServeUserId = async () => {
          if (!window.google?.ima) return
          const response = await fetch("https://sync.springserve.com/usersync/json")
          const data = await response.json()
          // adTagUrl = adTagUrl.replace("USER_ID", data.user_id)
        }

        await fetchSpringServeUserId()

        const infoPlayer = {
          src,
          contentId,
          id,

          signKey,
          licenseServer: "https://vtvlive.ondrm.vn/license-api/v1/drm/licenses/widevine",
          fairplayServer: "https://vtvlive.ondrm.vn/license-api/v1/drm/licenses/fairplay",
          fairplayCertificate: "https://ondrmstt.vtvcab.vn/license-api/v1/drm/licenses/fairplay-cert",
          drm: isProtected,
          isLive,
          allowTimeshift: isTimeshift,
          volume: isMobile || isSafari ? 0 : 0.8,
          isAdOn: !skip_ads,
          adTagUrl: adTagUrl,
          // muted: isMobile || isSafari ? true : false,
          // playsinline: isMobile ? true : false,

          // isAdOn: true,
          // adTagUrl: `https://network.innity.com/html5/preroll_video/?cb=${Date.now()}`,
          name,
          startTime,
          trackingUrl: "https://tracking.vtvlive.vn/api/v1/event_batch",
          iframeSrc: `${process.env.NEXT_PUBLIC_CHART_INTERACTIVE}/?id=${id}&name=${userInfo.id}&x-tenant-id=vtvlive`,
          isChartOn: true,
          ageLimitTag: age || "P",
          ageLimitDescription: content_warning,
          isChannel: isChannelRef.current
        }

        // 1. destroy instance cũ
        safeDestroyPlayer()

        // 2. iOS: hard reset DOM
        if (isIOS()) {
          console.log("[DBG-1] iOS detected → hardResetContainer()")
          hardResetContainer()
        }

        // 3. delay 1 frame cho Safari cleanup
        if (isIOS()) {
          console.log("[DBG-1] iOS → waiting 1 rAF frame for cleanup")
          // eslint-disable-next-line no-undef
          await new Promise((r) => requestAnimationFrame(r))
        }

        console.log("[DBG-1] Creating VinasportsPlayer with drm:", infoPlayer.drm, "| volume:", infoPlayer.volume)
        player = new VinasportsPlayer(container, infoPlayer, handleError)
        player.initialize()
        LiveOverlay?.leave()
        LiveOverlay?.attachTo(container)
        LiveOverlay?.join({
          mediaContentId: id,
          deviceId: getDeviceIdFromLocal(),
          deviceType: "web",
          type: isLive ? 1 : 2
        })
        player.trackingTime()
      } else {
        if (player) player.destroy()
        if (LiveOverlay) LiveOverlay.leave()
      }
    }

    initializePlayer()
  }, [src])

  useEffect(() => {
    const configOverlay = {
      api: process.env.NEXT_PUBLIC_ONPLAY,
      wss: process.env.NEXT_PUBLIC_WSS
    }
    LiveOverlay = window?.LiveOverlay
    LiveOverlay?.initialize({ ...configOverlay, iframeClass: "iframeClass" })
    return () => {
      LiveOverlay?.leave()
      player?.destroy()
    }
  }, [])

  useEffect(() => {
    const timer = setTimeout(() => {
      const tracking = getTracking()
      if (!tracking) return
      tracking.sendEvent({
        event_name: "view_content_details",
        content_id: isChannel ? channelId : id,
        content_title: name,
        content_type: !isLive ? 0 : isChannel ? 2 : 1,
        event_time: Math.floor(Date.now() / 1000)
      })
    }, 300)
    return () => clearTimeout(timer)
  }, [id, isChannel])

  return (
    <div className="relative">
      <div id="container" className="pt-[56%] md:pt-auto">
        <div>{children}</div>
      </div>
    </div>
  )
}

export default memo(VlinePlayer)
